export default {
  SET_LOADING (state, payload) {
    state.loading = payload
  },

  SET_LOADING_TEXT (state, payload) {
    state.loadingText = payload
  },
}
